import { Component, OnInit } from '@angular/core';
import { PaginationService } from 'src/app/helpers/pagination.service';
import { ToasterService } from 'src/app/helpers/toastr.service';
import { SellerReviewService } from './seller-reviews.service';

@Component({
  selector: 'app-seller-reviews',
  templateUrl: './seller-reviews.component.html',
  styleUrls: ['./seller-reviews.component.scss']
})
export class SellerReviewsComponent implements OnInit {

    public seller_records: any = [];
    public current_page: number = 1;
    public offset: number = 0;
    public page_per_view: number = 20;
    public seller_pagination: any = {};

    public page_per_view_options = [
        {
            value: 20,
            name: 20
        },
        {
            value: 40,
            name: 40
        }
    ];
    constructor(
        private _sellerreviews: SellerReviewService,
        private _toastr: ToasterService,
        private _pagination: PaginationService
    ) { }

    ngOnInit(): void {
        this.getsellerreviews();
    }

    getsellerreviews() {
        this._sellerreviews.getsellerreviews({ limit: this.page_per_view, offset: this.offset, current_page: this.current_page }).subscribe((data) => {
            if (data['status'] == "success") {
                this.seller_records = data['records'];
                let total_records = data['total_records'];
                this.seller_pagination = this._pagination.getPager(total_records, this.current_page, this.page_per_view);
            } else if (data['status'] == "error") {
                this._toastr.error(data['message']);
            }
        });
    }

    setpage(page) {
        this.current_page = page;
        this.offset = (page - 1) * this.page_per_view;
        this.getsellerreviews();
    }

    setpageperview() {
        this.current_page = 1;
        this.getsellerreviews();
    }

}
